module.exports = __webpack_public_path__ + "static/img/down_bg_ar.bfc785ed.png";